import axiosPrivate from "../../../api/axiosPrivate";
import {
  GET_DATA_FOR_UNDER_WRITERING,
  GET_POLICY_DOCUMENT,
  GET_POLICY_SCHEDULE_DOC,
  GET_SAVINGS_POLICY_DOCUMENT,
  GET_SAVINGS_POLICY_UNDERWRITING,
  SUBMIT_SAVINGS_UNDER_WRITERING,
  SUBMIT_UNDER_WRITERING,
} from "../../../api/constant";

const getUnderwritingData = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_DATA_FOR_UNDER_WRITERING}?customer_id=${data.customer_id}&policy_application_number=${data.policy_application_number}`
  );
  return response.data;
};
const submitUnderwriting = async (data) => {
  const response = await axiosPrivate.post(`${SUBMIT_UNDER_WRITERING}`, data);
  return response.data;
};

const getPolicyDocument = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_POLICY_DOCUMENT}?customer_id=${data.customer_id}&policy_app_no=${data.policy_application_number}`
  );
  return response.data;
};
const getPolicyScheduleDoc = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_POLICY_SCHEDULE_DOC}?customer_id=${data.customer_id}&policy_app_no=${data.policy_application_number}`
  );
  return response.data;
};

/** Savings Underwriting starts here  **/
const getSavingsunderwritingData = async (data) => {
  const res =
    await axiosPrivate.get(`${GET_SAVINGS_POLICY_UNDERWRITING}?customer_id=${data?.customer_id}&policy_application_number=${data?.policy_application_number}
  `);
  return res.data;
};

const submitSavingsUnderwriting = async (data) => {
  const response = await axiosPrivate.post(
    `${SUBMIT_SAVINGS_UNDER_WRITERING}`,
    data
  );
  return response.data;
};

const getPolicySavingsDocument = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_SAVINGS_POLICY_DOCUMENT}?customer_id=${data.customer_id}&policy_app_no=${data.policy_application_number}`
  );
  return response.data;
};

const underwritingService = {
  getUnderwritingData,
  submitUnderwriting,
  getPolicyDocument,
  getPolicyScheduleDoc,
  getSavingsunderwritingData,
  submitSavingsUnderwriting,
  getPolicySavingsDocument,
};

export default underwritingService;
